import React from 'react';
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import UserExistsView from '../Views/TO/Register/UserExistsView'

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();

class UserExists extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
        };
        this.startOver = this.startOver.bind(this);
    }

    startOver(){
        this.props.displayForm("CREATE")
    }

    render(){
        return(
            <UserExistsView 
            email = {this.props.email}
            startOver = {this.startOver}
            style = {this.props.style}
            />


          
    );

    }

}




export default UserExists;